import { render, staticRenderFns } from "./bidList.vue?vue&type=template&id=580f14d9&scoped=true"
import script from "./bidList.vue?vue&type=script&lang=js"
export * from "./bidList.vue?vue&type=script&lang=js"
import style0 from "./bidList.vue?vue&type=style&index=0&id=580f14d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580f14d9",
  null
  
)

export default component.exports